import { ObjectModel, Product } from '@types';
import { modelBelongsToProduct } from './model-belongs-to-product';

export const findModelByProduct = (models: ObjectModel[], product: Product) =>
    models.find(model => modelBelongsToProduct(product, model));
